import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import networkService from './services/NetworkService';
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.default.css';

// Initialize Pinia and Vue Router
const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);

// Global directive for searchable dropdowns using TomSelect
app.directive('searchable', {
    mounted(el) {
        // Prevent initializing on already initialized elements
        if (el.tomselect) return;
        
        const instance = new TomSelect(el, {
            create: false,
            sortField: {
                field: "text",
                direction: "asc"
            }
        });
        
        // Sync TomSelect changes back to Vue v-model
        instance.on('change', () => {
            el.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        el.tomselect = instance;
    },
    updated(el) {
        if (el.tomselect) {
            // Keep TomSelect's internal options in sync with Vue's reactivity
            el.tomselect.sync();
            
            // Strictly enforce that TomSelect's selected value matches Vue's DOM value
            // (Vue sets the .value property of the original select when v-model changes)
            if (el.tomselect.getValue() !== el.value) {
                el.tomselect.setValue(el.value, true); // silent update, no events
            }
            
            // Handle dynamically disabled selects
            if (el.disabled) {
                el.tomselect.disable();
            } else {
                el.tomselect.enable();
            }
        }
    },
    unmounted(el) {
        if (el.tomselect) {
            el.tomselect.destroy();
        }
    }
});

// Mount the application immediately for instant UI rendering
app.mount('#app');

// Smart Connection Detection: Find the fastest network path (LAN vs Internet) in the background.
// Axios interceptors will automatically use the active URL once detected without blocking the UI.
(async () => {
    console.log('[App] Detecting optimal network path in background...');
    await networkService.detectOptimalNetwork();
    
    // Start polling in the background (every 60 seconds) to detect if user switches networks
    networkService.startBackgroundPolling(60000);
})();
